module.exports = __webpack_public_path__ + "img/pageNotFound.1108ac06.jpg";